export default {
  talkToSis: {
    title: 'Talk to Us!',
    description:
      'Would you like to talk to one of our experts? So talk to us. We have a qualified team to meet your needs.',
    buttonText: 'Talk to SIS',
  },
}
